'use client';

import { c as _c } from "react/compiler-runtime";
import { useConfigProviderSafe } from '@material-bank/mtag-config';
import { MTAG_EVENTS, SOURCE_APP, trackBeforeNavigating, useAnalytics, useNavigationLatch } from '@material-bank/mtag-analytics';
import { getSignupUrl } from '../config/config';
import { buildSignupUrl } from '../lib/buildSignupUrl';
import { navigateWithFullReferrer } from '../lib/navigateWithFullReferrer';
export type UseCreateAccount = {
  isCreateAccountDisabled: boolean;
  createAccountClickHandler: () => void;
};

// The "Create account" action shared by the sign-in sheet's steps.
export function useCreateAccount() {
  const $ = _c(5);
  const config = useConfigProviderSafe();
  const {
    track
  } = useAnalytics();
  const claimCreateAccount = useNavigationLatch();
  const sourceId = config?.tagRef ?? null;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getSignupUrl();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const signupUrl = t0;
  let t1;
  if ($[1] !== claimCreateAccount || $[2] !== sourceId || $[3] !== track) {
    const createAccountClickHandler = function createAccountClickHandler() {
      if (signupUrl === null) {
        return;
      }
      if (!claimCreateAccount()) {
        return;
      }
      const url = buildSignupUrl({
        baseUrl: signupUrl,
        sourceId: sourceId ?? undefined,
        redirectUrl: window.location.href
      });
      const delivery = track(MTAG_EVENTS.CREATE_ACCOUNT_STEP, {
        source_app: SOURCE_APP,
        step_name: "EMAIL",
        step_status: "started",
        url: window.location.href
      });
      trackBeforeNavigating(delivery, () => navigateWithFullReferrer(url));
    };
    t1 = {
      isCreateAccountDisabled: signupUrl === null,
      createAccountClickHandler
    };
    $[1] = claimCreateAccount;
    $[2] = sourceId;
    $[3] = track;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}